import React from 'react';
import { formatLocalizedDateTime, useLocalize } from '@saviynt/common';
import { Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { msgs } from '../../../utilities/messages';
import { BLUE_KEY_SLOT } from '../constants';

/**
 * Center content of an access-key ListRow: the key name plus its start/expiry metadata.
 */
const KeyRowCenter = React.memo(({ keyItem }) => {
  const localize = useLocalize();
  const isActive = new Date(keyItem.startTime) <= new Date();
  const keyName =
    keyItem.slot === BLUE_KEY_SLOT
      ? localize(msgs.pam.apiKeys.blueKey)
      : localize(msgs.pam.apiKeys.greenKey);

  return (
    <div className='AccessKeysSection-rowCenter'>
      <Typography kind='h3'>{keyName}</Typography>
      <div className='AccessKeysSection-rowMeta'>
        <Typography kind='body2' color='--color-foreground-neutral-medium'>
          <span className='AccessKeysSection-rowMetaLabel'>
            {isActive
              ? localize(msgs.pam.apiKeys.active)
              : localize(msgs.pam.apiKeys.starts)}
          </span>
          {formatLocalizedDateTime(keyItem.startTime, false, false)}
        </Typography>
        <span className='AccessKeysSection-metaDot' aria-hidden='true'>
          {String.fromCharCode(183)}
        </span>
        <Typography kind='body2-bold' color='--color-foreground-warning-medium'>
          <span className='AccessKeysSection-rowMetaLabel'>
            {localize(msgs.pam.apiKeys.expires)}
          </span>
          {formatLocalizedDateTime(keyItem.expireTime, false, false)}
        </Typography>
      </div>
    </div>
  );
});

KeyRowCenter.propTypes = {
  keyItem: PropTypes.shape({
    slot: PropTypes.number.isRequired,
    startTime: PropTypes.string.isRequired,
    expireTime: PropTypes.string.isRequired,
  }).isRequired,
};

export default KeyRowCenter;
